import Vue from "vue";
import Router from "vue-router";
import HomePage from "../pages/HomePage.vue";
import AssetsPage from "../pages/AssetsPage.vue";
import OrdersPage from "../pages/OrdersPage.vue";
import VipPage from "../pages/VipPage.vue";
import ProjectSetupPage from "../pages/ProjectSetupPage.vue";
import StoryboardEditorPage from "../pages/StoryboardEditorPage.vue";
import VideoQuickCreatePage from "../pages/VideoQuickCreatePage.vue";
import CreatePage from "../pages/CreatePage.vue";
import QuickImagePage from "../pages/QuickImagePage.vue";
import HistoryPage from "../pages/HistoryPage.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    { path: "/", redirect: "/home" },
    { path: "/home", name: "home", component: HomePage },
    { path: "/quick-video", name: "quick-video", component: VideoQuickCreatePage },
    { path: "/quick-image", name: "quick-image", component: QuickImagePage },
    { path: "/create", name: "create", component: CreatePage },
    { path: "/history", name: "history", component: HistoryPage },
    { path: "/assets", name: "assets", component: AssetsPage },
    { path: "/orders", name: "orders", component: OrdersPage },
    { path: "/vip", name: "vip", component: VipPage },
    { path: "/project/setup", name: "project-setup", component: ProjectSetupPage },
    { path: "/project/storyboard-editor", name: "storyboard-editor", component: StoryboardEditorPage }
  ]
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("user_token");
  const needLogin =
    to.path === "/assets" ||
    to.path === "/orders" ||
    to.path === "/vip" ||
    to.path === "/quick-video" ||
    to.path === "/quick-image" ||
    to.path === "/create" ||
    to.path === "/history" ||
    to.path.indexOf("/project/") === 0;
  if (needLogin && !token) {
    sessionStorage.setItem("need_login_popup", "1");
    sessionStorage.setItem("pending_nav", to.fullPath);
    next("/home");
    return;
  }
  next();
});

export default router;
